<template>
  <v-container
    class='w-divided-in'
    fluid
  >
    <slot name="divided-in-content">
      <w-row dense>
        <slot />
      </w-row>
    </slot>
  </v-container>
</template>

<script>
export default { name: "WorkDividedInBase" }
</script>

<style lang="scss" scoped>
@import "../../../styles/app/reusable-styling";
.w-divided-in {
  padding: 0;
}
</style>
